function XCloseIco({ stroke, strokeWidth, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke={stroke || "#98A2B3"}
        stroke-width={strokeWidth || "2"}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default XCloseIco;
